import { useBreakpointValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TooltipHeader } from '$/pages/DashboardPages/components/TooltipHeader';

export const SubCollectionFloorHeader = () => {
  const { t } = useTranslation();

  const exploreText = useBreakpointValue(
    {
      base: t('dashboard.collection.search.floorCoverings'),
      md: t('dashboard.collection.exploreFloorCoverings'),
    },
    { ssr: false },
  );

  return (
    <TooltipHeader
      header={exploreText ?? t('dashboard.collection.filter.collection')}
    />
  );
};
